/* eslint-disable quotes */
import { snakelize, camelize } from "../../../helpers/object";

export default ($axios: any): any => ({
  // 캠페인 목록
  async index(data?: any) {
    return camelize(
      await $axios.get(`/campaign/images`, snakelize({ params: data }))
    );
  },

  // 이미지 업로드
  async uploadImage(data?: any) {
    const formData = new FormData();
    formData.append("image", data.image);
    formData.append("brand_token", data.brandToken);
    return camelize(await $axios.post("/campaign/images/upload", formData));
  },

  async store(data?: any) {
    return camelize(await $axios.post("/campaign/images", snakelize(data)));
  },

  async show(data?: any) {
    return camelize(
      await $axios.get(
        `/campaign/images/${data.campaignId}`,
        snakelize({ params: data })
      )
    );
  },

  async update(data?: any) {
    return camelize(
      await $axios.patch(`/campaign/images/${data.id}`, snakelize(data))
    );
  },

  async delete(data?: any) {
    await $axios.delete(
      `/campaign/images/${data.id}`,
      snakelize({ data: data })
    );
  },
});
